"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentType_1 = require("../helpers/getContentType");
const getSuccessStatusUpdatedEvent_1 = require("../helpers/getEvent/getSuccessStatusUpdatedEvent");
const getState_1 = require("../helpers/getState");
const getSuccessStatus_1 = require("../helpers/getSuccessStatus");
const entity_1 = require("../type/entity");
const isGradable_1 = require("./helpers/isGradable");
const updateSuccessStatusFieldsForAssignmentCard_1 = require("./helpers/updateSuccessStatusFieldsForAssignmentCard");
const updateSuccessStatusFieldsForCurriculum_1 = require("./helpers/updateSuccessStatusFieldsForCurriculum");
const updateSuccessStatusFieldsForNonLeafNode_1 = require("./helpers/updateSuccessStatusFieldsForNonLeafNode");
/**
 * If content is gradable, this function first calculates
 * rawScore and scaledScore, It then updates successStatus
 * field either based on (successCriteria + completion) for
 * assignment card or based on successRollupRules for
 * nonLeafNodes. Returns successStatusUpdatedEvent if
 * successStatus is updated.
 */
function updateSuccessStatus(command, user, content, states) {
    if (!isGradable_1.isGradable(content)) {
        return [];
    }
    const events = [];
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    const currentSuccessStatus = state.successStatus;
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.ASSIGNMENT_CARD:
            updateSuccessStatusFieldsForAssignmentCard_1.updateSuccessStatusFieldsForAssignmentCard(state, user, content, states);
            break;
        case entity_1.ContentType.CARD_QUESTION_FOR_REVIEW:
        case entity_1.ContentType.PEER_REVIEW_CARD:
        case entity_1.ContentType.SECTION:
        case entity_1.ContentType.COURSE:
            updateSuccessStatusFieldsForNonLeafNode_1.updateSuccessStatusFieldsForNonLeafNode(state, user, content, states);
            break;
        case entity_1.ContentType.CURRICULUM:
            updateSuccessStatusFieldsForCurriculum_1.updateSuccessStatusFieldsForCurriculum(state, user, content, states);
            break;
        default:
            break;
    }
    if (currentSuccessStatus !== state.successStatus) {
        const { userId, companyId } = user;
        const currentSuccessStatusEnum = getSuccessStatus_1.getSuccessStatus(currentSuccessStatus);
        const updatedSuccessStatusEnum = getSuccessStatus_1.getSuccessStatus(state.successStatus);
        if (updatedSuccessStatusEnum === entity_1.SuccessStatus.PASS) {
            state.successOn = command.timeStamp;
        }
        const successStatusUpdatedEvent = getSuccessStatusUpdatedEvent_1.getSuccessStatusUpdatedEvent(command, companyId, userId, content._id, contentType, currentSuccessStatusEnum, updatedSuccessStatusEnum);
        events.push(successStatusUpdatedEvent);
    }
    return events;
}
exports.updateSuccessStatus = updateSuccessStatus;
//# sourceMappingURL=updateSuccessStatus.js.map